import CheckDevice from '../../Modules/CheckDevice.js';
import * as CustomProperty from '../../Modules/CustomProperty.js';
import Animation from '../../Modules/Animation.js';
import DrawerMenu from '../../Modules/DrawerMenu.js';
import Modal from '../../Modules/Modal.js';
import * as UpdateStatus from '../../Modules/UpdateStatus.js';
import Slider from '../../Modules/Slider.js';
import * as CustomScroll from '../../Modules/CustomScroll.js';
import SmoothScroll from '../../Modules/SmoothScroll.js';
import * as BackToTop from './Modules/BackToTop.js';
import * as FadeOutEntryButton from './Modules/FadeOutEntryButton.js';
import * as MegaMenu from './Modules/MegaMenu.js';
import * as NavAccordion from './Modules/NavAccordion.js';
import * as PageTransition from './Modules/PageTransition.js';
import * as LinkArrow from './Modules/LinkArrow.js';
import * as BgParallax from '../../Modules/BgParallax.js';
import * as PlayVimeo from '../../Modules/PlayVimeo.js';
import * as PlayYoutube from '../../Modules/PlayYoutube.js';
import * as ScrollHint from './Modules/ScrollHint.js';


const preinit = (e) => {
  UpdateStatus.load();
}

const init = () => {
  UpdateStatus.load();
  CheckDevice();
  CustomProperty.init();
  PageTransition.init();
  Slider();
  DrawerMenu.init();
  Modal.init();
  CustomScroll.init();
  SmoothScroll();
  BackToTop.init();
  FadeOutEntryButton.init();
  MegaMenu.init();
  NavAccordion.init();
  LinkArrow.init();
  BgParallax.init();
  ScrollHint.init();
  PlayVimeo.init();
  PlayYoutube.init();
}

const pageChanged = () => {
  UpdateStatus.load();
  CheckDevice();
  CustomProperty.init();
  PageTransition.init();
  Slider();
  Modal.init();
  CustomScroll.init();
  BackToTop.init();
  FadeOutEntryButton.init();
  MegaMenu.init();
  NavAccordion.init();
  LinkArrow.init();
  BgParallax.init();
  ScrollHint.init();
  PlayVimeo.init();
}

const resize = () => {
  UpdateStatus.resize();
  CheckDevice();
  CustomProperty.resize();
  CustomScroll.resize();
}

const resizeW = () => {
  CustomProperty.resizeW();
  NavAccordion.resizeW();
  MegaMenu.resizeW();
}

const scroll = () => {
  UpdateStatus.scroll();
  CustomProperty.scroll();
  Animation();
}

const load = () => {
  UpdateStatus.load();
  Animation();

  const otContent = document.querySelectorAll('#ot-pc-content, #ot-lst-cnt')
  otContent.forEach((element) => {
    element.addEventListener('wheel',(e)=>{
      e.stopPropagation()
    })
  })
}

export {
  preinit,
  init,
  pageChanged,
  resize,
  resizeW,
  scroll,
  load
}